import { initStyles } from './init-styles'

void initStyles()
